import { ReducedMaterialsReport } from '@api/order-reporting/types/ReducedMaterialsReport';
import { ReducedMaterialsGridData } from '@pages/reporting-pages/reduced-materials/types/ReducedMaterialsGridData';
import { getParsedUnversionedSystemId, getParsedSystemId } from '@utils/getParsedSystemId';
import { format, parseISO } from 'date-fns';
import { valueExist } from '@utils/typescriptGuards';
import { renderLitresToHL, numberWithSpaces } from 'components/global/utils';



export const convertToGridData = (apiData: ReducedMaterialsReport[] | undefined | null): ReducedMaterialsGridData[] | null => {
	if (!apiData) return null;

	let gridData: ReducedMaterialsGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	

	gridData = apiData.map(x => ({
		...x,
		orderClientId: getParsedUnversionedSystemId(x.orderUnversionedSystemId).clientId,
		orderRequiredDeliveryDate: x.orderRequiredDeliveryDate ? format(parseISO(x.orderRequiredDeliveryDate), 'dd.MM.yyyy') : '-',
		orderRequiredDeliveryDateISO: x.orderRequiredDeliveryDate ? x.orderRequiredDeliveryDate : '-',
		materialClientId: getParsedSystemId(x.materialId).clientId,

		orderOriginalCount: valueExist(x.orderOriginalCount) ? numberWithSpaces(x.orderOriginalCount) : '0',
		orderSentCount: valueExist(x.orderSentCount) ? numberWithSpaces(x.orderSentCount) : '0',
		orderDeliveredCount: valueExist(x.orderDeliveredCount) ? numberWithSpaces(x.orderDeliveredCount) : '0',
		
		orderOriginalVolume: valueExist(x.orderOriginalVolume) ? renderLitresToHL(x.orderOriginalVolume, 2) : '0',
		orderSentVolume: valueExist(x.orderSentVolume) ? renderLitresToHL(x.orderSentVolume, 2) : '0',
		orderDeliveredVolume: valueExist(x.orderDeliveredVolume) ? renderLitresToHL(x.orderDeliveredVolume, 2) : '0',

		orderedMinusSentCount: valueExist(x.orderedMinusSentCount) ? numberWithSpaces(x.orderedMinusSentCount) : '0',
		sentMinusDeliveredCount: valueExist(x.sentMinusDeliveredCount) ? numberWithSpaces(x.sentMinusDeliveredCount) : '0',

		orderedMinusSentVolume: valueExist(x.orderedMinusSentVolume) ? renderLitresToHL(x.orderedMinusSentVolume, 2) : '0',
		sentMinusDeliveredVolume: valueExist(x.sentMinusDeliveredVolume) ? renderLitresToHL(x.sentMinusDeliveredVolume, 2) : '0',
	}));

	return gridData
}